<script>
import headBox from "@/components/head.vue"
import footBox from "@/components/foot.vue"
import {getText} from "@/utils/text";

export default {
  components: {headBox, footBox},
  data() {
    return {}
  },
  mounted() {
    //滚动到顶部
    window.scrollTo(0, 0)
  },
  methods: {
    getViewText(key) {
      return getText(key)
    }
  }
}
</script>


<template>
  <div>
    <headBox/>

    <section id="content" lang=ZH-CN style='tab-interval:21.0pt;word-wrap:break-word;text-justify-trim:
punctuation'>

      <div :class="$store.state.isPhone?'WordSection':'WordSection1'" style='layout-grid:15.6pt'>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:16.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>{{ getViewText('game_introduction') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>
  {{ getViewText('g_1') }}
</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>{{ getViewText('target_audience') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>
          {{ getViewText('g_2')}}
        </span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>
          {{ getViewText('g_3')}}
        </span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('g_4')}}</span><b><span
          lang=EN-US style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
mso-fareast-font-family:����;mso-fareast-theme-font:minor-fareast'></span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>{{ getViewText('core_gameplay_features') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{getViewText('skill_challenge')}}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{
            getViewText('g_5')
          }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('secure_payments') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{
            getViewText('g_6')
          }} </span><span
          lang=EN-US style='mso-bidi-font-size:10.5pt;line-height:200%;font-family:"Meiryo",sans-serif;
mso-fareast-font-family:����;mso-fareast-theme-font:minor-fareast'>Paytm, Google
Pay, and PhonePe,</span><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'> {{ getViewText('g_7')}}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('diverse_game_modes') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{
            getViewText('g_8')
          }}</span><b><span lang=EN-US
                                                                  style='font-size:14.0pt;line-height:200%;font-family:"Meiryo",sans-serif;
mso-fareast-font-family:����;mso-fareast-theme-font:minor-fareast'></span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='font-size:14.0pt;line-height:
200%;font-family:"Meiryo",sans-serif'>{{ getViewText('player_experience')}}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('user_interface_design') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{
            getViewText('g_9')
          }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('community_interaction') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{
            getViewText('g_10')
          }}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('continuous_updates') }}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('g_11')}}</span></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('support_and_feedback')}}</span></b></p>

        <p class=MsoNormal align=left style='margin-top:15.6pt;
margin-bottom:15.6pt;text-align:
left;line-height:200%'><span lang=EN-US style='mso-bidi-font-size:10.5pt;
line-height:200%;font-family:"Meiryo",sans-serif'>{{ getViewText('g_12')}}</span></p>

      </div>

    </section>


    <footBox/>
  </div>
</template>
<style>
.WordSection1 {
  margin-left: 105.0pt;
  margin-right: 105.0pt;
  color: #fff
}

.WordSection {
  margin-left: 50px;
  margin-right: 50px;
  color: #fff
}
</style>



// WEBPACK FOOTER //
// src/views/gameIntroduction.vue